import HeroButton from "@components/HeroButton";
import Image from "next/image";
import React from "react";
interface TitleCardProps {
    chipTitle: string;
    mainTitle: string | JSX.Element;
    description: string | JSX.Element;
    simpleText: string;
    buttonText?: string;
    variantColor: string;
    chipBg: string;
    chipBorder: string;
    chipTextColor: string;
    imageLink: string;
}

const TemplateHeader: React.FC<TitleCardProps> = (props) => {
    const { chipTitle, mainTitle, description, simpleText, buttonText, variantColor, chipBg, chipBorder, chipTextColor, imageLink } = props;
    return (
        <section className="lg:mt-14 py-10 lg:py-20 lg:px-0 px-5" style={{ background: variantColor }}>
            <div className="max-w-6xl mx-auto flex flex-col gap-8 lg:flex-row justify-between items-center">
                <div className="flex flex-col lg:w-1/2 items-center lg:items-start">
                    <h1
                        className="px-4 py-2 rounded-full lg:text-base text-sm font-medium text-green-700 bg-green-100 flex flex-row gap-2 items-center flex-nowrap whitespace-nowrap w-fit border border-solid border-green-700"
                        style={{ background: chipBg, color: chipTextColor, borderColor: chipBorder }}
                    >
                        {chipTitle}
                    </h1>
                    <h2 className="flex lg:justify-start justify-center lg:text-5xl  lg:font-bold text-2xl text-gray-800 my-6 mr-4 lg:leading-tight">{mainTitle}</h2>
                    <p className="lg:text-base font-normal text-center lg:text-left  text-gray-700">{description}</p>
                    <p className="mt-3 lg:text-base font-normal text-center lg:text-left text-gray-700">{simpleText}</p>

                    <div className="my-4">
                        <HeroButton buttontext={buttonText} alignLayout="flex-col gap-4 md:flex-row" bookDemoButtonClass="w-full py-3" />
                    </div>
                </div>
                <Image height={80} width={500} src={imageLink} alt="whatsapp icon" />
            </div>
        </section>
    );
};

export default TemplateHeader;
